export default __webpack_public_path__ + "static/media/Billing Status2.a47c60c1.svg";